import { computed } from 'vue'
import useCurrentInstance from '~/utils/useCurrentInstance'

export const DEFAULT_HIDDEN_PRICE_SYMBOL = '-'

export default function useHidePrices() {
  const vm = useCurrentInstance()
  const isHiddenPrices = computed(() => vm.$nuxt.$store?.getters['layout/isHiddenPrices'])

  const ifShowPrices = (value: any) => {
    return value && isHiddenPrices.value ? DEFAULT_HIDDEN_PRICE_SYMBOL : value
  }

  return {
    isHiddenPrices,
    ifShowPrices,
  }
}
